<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<common-code-search :scrId="scrId" />
			</sf-card>
		</div>
		<div class="sf-col sf-col-20">
			<el-row :gutter="20" class="h-100 w-100 m-0">
				<el-col :span="12" class="h-100 pl-0">
					<comm-cd-type-table :scrId="scrId" />
				</el-col>
				<el-col :span="12" class="h-100 pr-0">
					<comm-cd-table :scrId="scrId" ref="tableSection" />
				</el-col>
			</el-row>
		</div>
		<comm-cd-desc-modal :scrId="scrId" />
		<comm-cd-lang-modal :scrId="scrId" @setName="setName" />
	</div>
</template>

<script>
import CommonCodeSearch from './Search/CommonCodeSearch.vue';
import CommCdTable from './Table/CommCdTable.vue';
import CommCdTypeTable from './Table/CommCdTypeTable.vue';
import { CommCdDescModal, CommCdLangModal } from '@common/CommonCode/Content/Modal';
export default {
	components: { CommonCodeSearch, CommCdTable, CommCdTypeTable, CommCdDescModal, CommCdLangModal },
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		setName(param) {
			if (param != null) {
				this.$refs.tableSection.setMenuName(param);
			}
		}
	}
};
</script>

<style></style>
